<template>
  <div class="layout-with-centered-max-width-child">
    <div>
      <div class="header">
        <span class="font-secondary">My Dashboard</span>
      </div>
      <div v-if="userHasPurchases" class="tabs">
        <div v-for="(tab, i) in tabs" :class="tab.classObj" @click="onTabClick(i)" :key="i">
          <div class="pdng-1 vertical">
            <span>{{tab.name}}</span>
          </div>
        </div>
      </div>
      <MyPurchases v-if="myPurchases"></MyPurchases>
      <MyStudies v-else></MyStudies>
    </div>
  </div>
</template>

<script>

  import MyStudies from "./views/MyStudies"
  import {
    CSS_CLASS_NAME_SELECTED_TAB,
    GET_PURCHASES_OF_USER,
    R_NAME_DASHBOARD,
    R_NAME_PURCHASES
  } from "../services/constants"
  import MyPurchases from "./views/MyPurchases"
  import {mapGetters} from "vuex"

  export default {
    name: 'Dashboard',
    components: {MyPurchases, MyStudies},

    created(){
      this.selectedTabIndex = this.getTabIndex
    },

    data(){
      return{
        selectedTabIndex: this.getTabIndex
      }
    },

    computed: {
      ...mapGetters([
        GET_PURCHASES_OF_USER
      ]),
      tabNames() {
        return [
          'My Studies',
          'My Purchases',
        ]
      },
      tabs() {
        return this.tabNames.map((tabName, i) => {
          const isSelected = i === this.selectedTabIndex
          return {
            name: tabName,
            isSelected,
            classObj: {
              [CSS_CLASS_NAME_SELECTED_TAB]: isSelected
            },
          }
        })
      },
      myPurchases(){
        return this.$route.name === R_NAME_PURCHASES
      },
      getTabIndex(){
        return this.myPurchases ? 1 : 0
      },
      userHasPurchases() {
        return this[GET_PURCHASES_OF_USER].length > 0
      },
    },

    methods: {
      onTabClick(index) {
        this.selectedTabIndex = index
        if(index === 1){
          this.$router.push({name: R_NAME_PURCHASES})
        }
        else {
          this.$router.push({name: R_NAME_DASHBOARD})
        }
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../scss/main";

  .header{
    padding: 30px 0;
    font-weight: bolder;
    font-size: 16pt;
    color: $red-2;
    margin: 0 60px;
  }

  .tabs {
    padding-bottom: 30px;
    display: flex;
    margin: 0 60px;
    > div {
      width: 50%;
      display: flex;
      justify-content: center;
      margin: 0 1px;
      cursor: pointer;
      background-color: $cyan-blue-2;
      color: $cyan-1;
      font-size: 15px;
      &.selected-tab {
        background-color: $cyan-blue-3;
        color: $white-1;
      }
    }
  }



</style>
